import React from 'react';

import CopyAllIcon from '@mui/icons-material/CopyAll';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import { Stack } from '@mui/material';
import { ConfirmDialog } from '../../../../components/ConfirmDialog';
import { useParameterizedQuery } from 'react-fetching-library';
import { duplicateEmployeeApplication } from '../../../../services/request';
import { useApplication } from '../ApplicationsContext';

export const Duplicate = ({ rowData }) => {
  const ctx = useApplication();
  const { query } = useParameterizedQuery(duplicateEmployeeApplication);
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [confirmDeleteOpen, setConfirmDeleteOpen] = React.useState(false);

  const handleDuplicate = async () => {
    const { error, payload } = await query(rowData.id);
    console.log(error);
    if (!error) {
      ctx.query();
    } else {
      console.log('err3');
    }
  };

  return (
    <Stack>
      <Tooltip title="Duplikuj">
        <IconButton
          color="primary"
          onClick={() => setConfirmDeleteOpen(true)}
        >
          <CopyAllIcon />
        </IconButton>
      </Tooltip>
      <ConfirmDialog
        title="Utworzyć duplikat?"
        open={confirmDeleteOpen}
        setOpen={setConfirmDeleteOpen}
        onConfirm={handleDuplicate}
        // disabled={loading}
      >
        Czy na pewno chcesz utworzyć duplikat tej aplikacji?
      </ConfirmDialog>
    </Stack>

  );
};
export default Duplicate;
